import { toast } from "sonner";
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell,
} from "recharts";

export default function AdminReportsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.adminReports().then((r) => setData(r.data)).catch(() => toast.error("Couldn't load reports")).finally(() => setLoading(false)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-semibold">Reports</h1>
        <p className="text-muted-foreground text-sm">Platform-level (no revenue data).</p>
      </div>
      {loading || !data ? <Skeleton className="h-64 w-full" /> : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <Chart title="Leads by city" data={data.leads_per_city} dataKey="count" labelKey="city" testid="report-leads-by-city" />
          <Chart title="Leads by business type" data={data.leads_per_business_type} dataKey="count" labelKey="type" testid="report-leads-by-type" />
        </div>
      )}
    </div>
  );
}

const Chart = ({ title, data, dataKey, labelKey, testid }) => (
  <Card className="p-5" data-testid={testid}>
    <h3 className="font-heading text-base font-semibold mb-3">{title}</h3>
    <div style={{ width: "100%", height: 260 }}>
      {!data || data.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-12">No data yet.</p>
      ) : (
        <ResponsiveContainer>
          <BarChart data={data}>
            <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" />
            <XAxis dataKey={labelKey} tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} />
            <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 12 }} />
            <Bar dataKey={dataKey} radius={[8,8,0,0]} fill="hsl(var(--primary))" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  </Card>
);
